



















import { Component } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { mixins } from 'vue-class-component'
import AccountOptionsComponent from '@/shared/views/AccountOptionsComponent.vue'
import AccountOptionsMixin from '@/components/mixins/AccountOptionsMixin.vue'
import DeliveryRule from '@/api/models/DeliveryRule'

@Component({
    components: {
        AccountOptionsComponent
    }
})

export default class AccountOptionsBase extends mixins(AccountOptionsMixin) {
    @Action('getDeliveryRules')
    private getDeliveryRules: (accountId: number) => Promise<Array<DeliveryRule>>

    protected hasDeliveryCostRules = false

    protected async loadData(): Promise<void> {
        this.setLoading(true)
        this.hasDeliveryCostRules = false
        try {
            if (this.currentAccount?.id) {
                const accountId = Number(this.currentAccount.id)
                this.accountOptions = await this.accountService.getAccountOptions(this.currentAccount.id)
                this.productProperties = await this.refService.getProductProperties(this.currentAccount.id)
                const rules = await this.getDeliveryRulesSafe(accountId)

                this.hasDeliveryCostRules = rules.length > 0
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.internal.getAccountOptionsError').toString()
        } finally {
            this.setLoading(false)
        }
    }

    private async getDeliveryRulesSafe(accountId: number): Promise<Array<DeliveryRule>> {
        try {
            return await this.getDeliveryRules(accountId)
        } catch {
            return []
        }
    }
}
